// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__1pxae","content":"TermsOfServicePage_content__1dat0"};